import { apiGet, apiPatch, apiDelete } from './client';
import type { AppNotification, PaginatedResponse } from './types';

export interface UnreadCountResponse {
  count: number;
}

export function fetchNotifications(page = 1, limit = 20, unreadOnly = false) {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    unreadOnly: String(unreadOnly),
  });
  return apiGet<PaginatedResponse<AppNotification>>(`/notifications?${params}`);
}

export function fetchUnreadCount() {
  return apiGet<UnreadCountResponse>('/notifications/unread-count');
}

export function markAsRead(id: string) {
  return apiPatch<AppNotification>(`/notifications/${id}/read`);
}

export function markAllAsRead() {
  return apiPatch<{ updated: number }>('/notifications/read-all');
}

export function deleteNotification(id: string) {
  return apiDelete<void>(`/notifications/${id}`);
}
